import { parsePropTypes } from './prop-types';

function defaultGetUniforms(module, props) {
  var uniforms = {};

  if (props === undefined) {
    for (var key in module.uniforms) {
      uniforms[key] = module.uniforms[key].value;
    }

    return uniforms;
  }

  for (var _key in props) {
    // TODO validate, clamp etc
    uniforms[_key] = props[_key];
  }

  return uniforms;
} // Note: modifies and returns the same module


export function normalizeShaderModule(module) {
  if (!module.normalized) {
    module.normalized = true; // Normalize uniforms

    if (module.uniforms) {
      var _parsePropTypes = parsePropTypes(module.uniforms),
          propTypes = _parsePropTypes.propTypes;

      module.uniforms = propTypes;
    } // Build a getUniforms from the uniforms array


    if (module.uniforms && !module.getUniforms) {
      module.getUniforms = defaultGetUniforms.bind(null, module);
    }
  }

  return module;
}
//# sourceMappingURL=normalize-module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/esm/shadertools/src/lib/filters/normalize-module.js
// module id = 641
// module chunks = 0